import { useUserContext } from '../../context/UserContext';

const UserName = () => {
  const { userInfo, userLoggedIn } = useUserContext();

  if (!userLoggedIn) {
    return <span className="name">Guest</span>;
  }
  else {
    return <span className="name">{userInfo.first_name + ' ' + userInfo.last_name}</span>;
  }     

};

export default UserName;